import { TextInput } from '../../atoms/TextInput';
import { ActionIcon } from '../../atoms/ActionIcon';
import { Group } from '../../atoms/Group';
import { Icon } from '../../atoms/Icon';
import { IconSearch, IconX } from '@tabler/icons-react';
import type { CoreProps } from '../../types';
import { useShouldRender } from '../../../hooks/useShouldRender';

export interface SearchBarProps extends CoreProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchBar({
  value,
  onChange,
  placeholder = 'Search...',
  testId,
  view = 'all',
}: SearchBarProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;

  return (
    <Group gap="xs" data-testid={testId} wrap="nowrap">
      <TextInput
        flex={1}
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        placeholder={placeholder}
        leftSection={<Icon icon={IconSearch} size={16} />}
        rightSection={
          value ? (
            <ActionIcon variant="subtle" onClick={() => onChange('')} aria-label="Clear">
              <Icon icon={IconX} size={14} />
            </ActionIcon>
          ) : null
        }
      />
    </Group>
  );
}
